module.exports = __webpack_public_path__ + "static/media/cover.f63ec87b.jpg";